export interface KuwaitProduct {
  id: string;
  name: string;
  samplePrice: number;
  bulkPrice: number;
  moq: number;
  image: string;
  category: string;
}

export interface KuwaitFactory {
  id: string;
  name: string;
  city: string;
  established: number;
  employees: string;
  verified: boolean;
  dropshipping: boolean;
  warehouseCountries?: string[];
  rating: number;
  responseRate: string;
  onTimeDelivery: string;
  productCount: number;
  categories: string[];
  description: string;
  logo: string;
  coverImage: string;
  products: KuwaitProduct[];
}

export const kuwaitFactories: KuwaitFactory[] = [
  {
    id: "kf1",
    name: "Kuwait Petroleum Products Co.",
    city: "Kuwait City",
    established: 2001,
    employees: "500–1000",
    verified: true,
    dropshipping: false,
    rating: 4.8,
    responseRate: "96%",
    onTimeDelivery: "95%",
    productCount: 980,
    categories: ["Chemicals", "Industrial", "Oil & Gas"],
    description: "One of Kuwait's leading industrial chemical and petroleum product manufacturers. Supplying high-grade industrial chemicals, lubricants, and specialty oils to global markets.",
    logo: "https://public.readdy.ai/ai/img_res/b79d26d729f814dddcc17fa4cc8d3095.jpg",
    coverImage: "https://readdy.ai/api/search-image?query=Kuwait%20City%20modern%20industrial%20petroleum%20factory%20plant%20production%20professional%20bright%20clean%20aerial%20view%20oil%20refinery&width=800&height=400&seq=kfc1&orientation=landscape",
    products: [
      {
        id: "kf1p1",
        name: "Industrial Lubricant Oil 20L",
        samplePrice: 75,
        bulkPrice: 28,
        moq: 50,
        category: "Industrial",
        image: "https://readdy.ai/api/search-image?query=industrial%20lubricant%20oil%2020L%20drum%20professional%20white%20background%20product%20photography%20clean%20industrial%20petroleum&width=400&height=400&seq=kf1p1&orientation=squarish",
      },
      {
        id: "kf1p2",
        name: "Specialty Chemical Compound 25kg",
        samplePrice: 120,
        bulkPrice: 45,
        moq: 20,
        category: "Chemicals",
        image: "https://readdy.ai/api/search-image?query=specialty%20chemical%20compound%2025kg%20bag%20industrial%20white%20background%20product%20photography%20professional%20clean%20manufacturing&width=400&height=400&seq=kf1p2&orientation=squarish",
      },
      {
        id: "kf1p3",
        name: "High-Grade Petroleum Wax 10kg",
        samplePrice: 55,
        bulkPrice: 18,
        moq: 100,
        category: "Oil & Gas",
        image: "https://readdy.ai/api/search-image?query=high%20grade%20petroleum%20wax%2010kg%20block%20white%20background%20product%20photography%20professional%20clean%20industrial%20material&width=400&height=400&seq=kf1p3&orientation=squarish",
      },
    ],
  },
  {
    id: "kf2",
    name: "Al Soor Food Industries",
    city: "Shuwaikh",
    established: 2008,
    employees: "200–500",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Kuwait", "UAE", "Saudi Arabia", "UK", "USA"],
    rating: 4.9,
    responseRate: "97%",
    onTimeDelivery: "96%",
    productCount: 640,
    categories: ["Food & Beverage", "Dairy", "Snacks"],
    description: "Premium halal food manufacturer in Shuwaikh Industrial Area. Producing dairy products, snacks, and packaged foods for global retail and wholesale markets with full dropshipping support.",
    logo: "https://readdy.ai/api/search-image?query=food%20company%20logo%20gold%20wheat%20grain%20emblem%20white%20background%20Kuwait%20food%20industries%20corporate%20identity%20professional&width=80&height=80&seq=kfl2&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Kuwait%20Shuwaikh%20food%20factory%20production%20line%20dairy%20snacks%20packaging%20workers%20professional%20bright%20clean%20modern%20interior&width=800&height=400&seq=kfc2&orientation=landscape",
    products: [
      {
        id: "kf2p1",
        name: "Halal Dairy Assortment Pack (24 units)",
        samplePrice: 38,
        bulkPrice: 14,
        moq: 100,
        category: "Dairy",
        image: "https://readdy.ai/api/search-image?query=halal%20dairy%20assortment%20pack%2024%20units%20premium%20packaging%20white%20background%20product%20photography%20professional%20clean%20food%20Kuwait&width=400&height=400&seq=kf2p1&orientation=squarish",
      },
      {
        id: "kf2p2",
        name: "Arabic Mixed Nuts Premium Box 500g",
        samplePrice: 42,
        bulkPrice: 16,
        moq: 50,
        category: "Snacks",
        image: "https://readdy.ai/api/search-image?query=Arabic%20mixed%20nuts%20premium%20box%20500g%20luxury%20gold%20packaging%20white%20background%20product%20photography%20professional%20food%20snack&width=400&height=400&seq=kf2p2&orientation=squarish",
      },
      {
        id: "kf2p3",
        name: "Kuwaiti Halwa Traditional Sweet 1kg",
        samplePrice: 55,
        bulkPrice: 22,
        moq: 30,
        category: "Food & Beverage",
        image: "https://readdy.ai/api/search-image?query=Kuwaiti%20halwa%20traditional%20sweet%201kg%20luxury%20Arabic%20dessert%20gold%20packaging%20white%20background%20product%20photography%20premium&width=400&height=400&seq=kf2p3&orientation=squarish",
      },
    ],
  },
  {
    id: "kf3",
    name: "Gulf Construction Materials LLC",
    city: "Ahmadi",
    established: 2005,
    employees: "200–500",
    verified: true,
    dropshipping: false,
    rating: 4.7,
    responseRate: "93%",
    onTimeDelivery: "92%",
    productCount: 720,
    categories: ["Construction", "Steel", "Building Materials"],
    description: "Major construction materials supplier in Ahmadi. Providing structural steel, cement products, and building materials for large-scale construction projects across the Gulf region.",
    logo: "https://readdy.ai/api/search-image?query=construction%20company%20logo%20gold%20building%20emblem%20white%20background%20Kuwait%20Gulf%20corporate%20identity%20professional%20minimalist&width=80&height=80&seq=kfl3&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Kuwait%20Ahmadi%20construction%20materials%20factory%20steel%20production%20workers%20professional%20bright%20industrial%20modern%20interior&width=800&height=400&seq=kfc3&orientation=landscape",
    products: [
      {
        id: "kf3p1",
        name: "Structural Steel I-Beams (6m)",
        samplePrice: 380,
        bulkPrice: 145,
        moq: 10,
        category: "Steel",
        image: "https://readdy.ai/api/search-image?query=structural%20steel%20I-beams%206m%20construction%20material%20white%20background%20product%20photography%20professional%20industrial%20metal%20building&width=400&height=400&seq=kf3p1&orientation=squarish",
      },
      {
        id: "kf3p2",
        name: "High-Strength Cement Bags (50kg)",
        samplePrice: 18,
        bulkPrice: 6,
        moq: 200,
        category: "Building Materials",
        image: "https://readdy.ai/api/search-image?query=high%20strength%20cement%20bags%2050kg%20construction%20material%20white%20background%20product%20photography%20professional%20clean%20building&width=400&height=400&seq=kf3p2&orientation=squarish",
      },
      {
        id: "kf3p3",
        name: "Reinforced Concrete Blocks (100pcs)",
        samplePrice: 95,
        bulkPrice: 35,
        moq: 50,
        category: "Construction",
        image: "https://readdy.ai/api/search-image?query=reinforced%20concrete%20blocks%20100pcs%20construction%20material%20white%20background%20product%20photography%20professional%20clean%20building&width=400&height=400&seq=kf3p3&orientation=squarish",
      },
    ],
  },
  {
    id: "kf4",
    name: "Kuwait Luxury Perfumes House",
    city: "Kuwait City",
    established: 2014,
    employees: "50–100",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Kuwait", "UAE", "Saudi Arabia", "UK", "France", "Germany"],
    rating: 4.9,
    responseRate: "98%",
    onTimeDelivery: "97%",
    productCount: 380,
    categories: ["Beauty", "Fragrance", "Luxury"],
    description: "Exclusive Kuwaiti luxury perfume house crafting authentic Arabic oud, bakhoor, and designer fragrances. Offering private label and global dropshipping to retailers worldwide.",
    logo: "https://readdy.ai/api/search-image?query=luxury%20perfume%20house%20logo%20gold%20oud%20crescent%20emblem%20white%20background%20Kuwait%20fragrance%20corporate%20identity%20elegant&width=80&height=80&seq=kfl4&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Kuwait%20luxury%20perfume%20factory%20production%20elegant%20fragrance%20bottles%20oud%20bakhoor%20interior%20professional%20bright%20clean&width=800&height=400&seq=kfc4&orientation=landscape",
    products: [
      {
        id: "kf4p1",
        name: "Kuwait Royal Oud Perfume 100ml",
        samplePrice: 95,
        bulkPrice: 32,
        moq: 24,
        category: "Fragrance",
        image: "https://readdy.ai/api/search-image?query=Kuwait%20royal%20oud%20perfume%20100ml%20luxury%20gold%20bottle%20elegant%20design%20white%20background%20product%20photography%20premium%20fragrance&width=400&height=400&seq=kf4p1&orientation=squarish",
      },
      {
        id: "kf4p2",
        name: "Arabic Bakhoor Luxury Gift Set",
        samplePrice: 65,
        bulkPrice: 24,
        moq: 30,
        category: "Beauty",
        image: "https://readdy.ai/api/search-image?query=Arabic%20bakhoor%20luxury%20gift%20set%20gold%20packaging%20elegant%20white%20background%20product%20photography%20premium%20Middle%20East%20fragrance&width=400&height=400&seq=kf4p2&orientation=squarish",
      },
      {
        id: "kf4p3",
        name: "Dehn Al Oud Pure Oil 12ml",
        samplePrice: 120,
        bulkPrice: 48,
        moq: 12,
        category: "Fragrance",
        image: "https://readdy.ai/api/search-image?query=Dehn%20Al%20Oud%20pure%20oil%2012ml%20luxury%20Arabic%20perfume%20bottle%20gold%20elegant%20white%20background%20product%20photography%20premium&width=400&height=400&seq=kf4p3&orientation=squarish",
      },
    ],
  },
  {
    id: "kf5",
    name: "Jahra Textile & Garment Factory",
    city: "Jahra",
    established: 2016,
    employees: "50–100",
    verified: false,
    dropshipping: true,
    warehouseCountries: ["Kuwait", "UAE", "Turkey", "India"],
    rating: 4.3,
    responseRate: "84%",
    onTimeDelivery: "87%",
    productCount: 290,
    categories: ["Textiles", "Clothing", "Uniforms"],
    description: "Growing garment manufacturer in Jahra offering custom uniforms, traditional Arabic clothing, and branded sportswear with competitive pricing and dropshipping support.",
    logo: "https://readdy.ai/api/search-image?query=textile%20garment%20company%20logo%20gold%20needle%20thread%20emblem%20white%20background%20Jahra%20Kuwait%20fabric%20manufacturing%20corporate&width=80&height=80&seq=kfl5&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Jahra%20Kuwait%20textile%20garment%20factory%20sewing%20machines%20workers%20clothing%20production%20professional%20bright%20interior%20modern&width=800&height=400&seq=kfc5&orientation=landscape",
    products: [
      {
        id: "kf5p1",
        name: "Traditional Kuwaiti Dishdasha (White)",
        samplePrice: 48,
        bulkPrice: 18,
        moq: 30,
        category: "Clothing",
        image: "https://readdy.ai/api/search-image?query=traditional%20Kuwaiti%20dishdasha%20white%20elegant%20garment%20white%20background%20product%20photography%20premium%20clothing%20Middle%20East&width=400&height=400&seq=kf5p1&orientation=squarish",
      },
      {
        id: "kf5p2",
        name: "Custom Embroidered Corporate Polo",
        samplePrice: 24,
        bulkPrice: 9,
        moq: 50,
        category: "Uniforms",
        image: "https://readdy.ai/api/search-image?query=custom%20embroidered%20corporate%20polo%20shirt%20professional%20white%20background%20product%20photography%20clean%20business%20workwear%20Kuwait&width=400&height=400&seq=kf5p2&orientation=squarish",
      },
      {
        id: "kf5p3",
        name: "Premium Abaya Fabric Roll (10m)",
        samplePrice: 85,
        bulkPrice: 32,
        moq: 20,
        category: "Textiles",
        image: "https://readdy.ai/api/search-image?query=premium%20abaya%20fabric%20roll%2010m%20black%20elegant%20textile%20material%20white%20background%20product%20photography%20luxury%20Middle%20East&width=400&height=400&seq=kf5p3&orientation=squarish",
      },
    ],
  },
  {
    id: "kf6",
    name: "Kuwait Smart Electronics Co.",
    city: "Salmiya",
    established: 2018,
    employees: "100–200",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Kuwait", "UAE", "Saudi Arabia", "USA", "UK", "Germany"],
    rating: 4.8,
    responseRate: "96%",
    onTimeDelivery: "95%",
    productCount: 510,
    categories: ["Electronics", "Smart Home", "Accessories"],
    description: "Modern electronics manufacturer in Salmiya specializing in smart home devices, consumer electronics, and IoT accessories. Full global dropshipping with fast delivery from 6 warehouse locations.",
    logo: "https://readdy.ai/api/search-image?query=smart%20electronics%20company%20logo%20gold%20circuit%20chip%20emblem%20white%20background%20Salmiya%20Kuwait%20technology%20corporate%20identity%20modern&width=80&height=80&seq=kfl6&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Salmiya%20Kuwait%20smart%20electronics%20factory%20clean%20room%20production%20IoT%20devices%20consumer%20electronics%20professional%20bright%20modern&width=800&height=400&seq=kfc6&orientation=landscape",
    products: [
      {
        id: "kf6p1",
        name: "Smart WiFi Power Strip 6-Port",
        samplePrice: 45,
        bulkPrice: 16,
        moq: 30,
        category: "Smart Home",
        image: "https://readdy.ai/api/search-image?query=smart%20WiFi%20power%20strip%206%20port%20modern%20sleek%20design%20white%20background%20product%20photography%20professional%20tech%20electronics%20home&width=400&height=400&seq=kf6p1&orientation=squarish",
      },
      {
        id: "kf6p2",
        name: "Wireless Charging Pad 15W",
        samplePrice: 35,
        bulkPrice: 12,
        moq: 50,
        category: "Accessories",
        image: "https://readdy.ai/api/search-image?query=wireless%20charging%20pad%2015W%20modern%20sleek%20design%20white%20background%20product%20photography%20professional%20tech%20electronics%20accessories&width=400&height=400&seq=kf6p2&orientation=squarish",
      },
      {
        id: "kf6p3",
        name: "Smart Air Quality Monitor",
        samplePrice: 88,
        bulkPrice: 34,
        moq: 20,
        category: "Smart Home",
        image: "https://readdy.ai/api/search-image?query=smart%20air%20quality%20monitor%20modern%20sleek%20design%20white%20background%20product%20photography%20professional%20tech%20IoT%20home%20device&width=400&height=400&seq=kf6p3&orientation=squarish",
      },
    ],
  },
];
